export default __webpack_public_path__ + "static/media/pin_delivery_bot.57f6a3c9.png";